<template>
  <div>
    
    <!--begin::Signin-->
    <div class="login-form login-signin">
      <div class="text-center mb-10 mb-lg-20">
        <h3 class="font-size-h1">ورود</h3>
        <p class="text-muted font-weight-semi-bold">تلفن همراه و رمز عبور خود را وارد کن</p>
      </div>

      <!--begin::Form-->
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <!-- <div role="alert" class="alert alert-info">
          <div class="alert-text">
            Use account <strong>admin@demo.com</strong> and password
            <strong>demo</strong> to continue.
          </div>
        </div>-->

        <div role="alert" v-bind:class="{ show: errors.length }" class="alert fade alert-danger">
          <div class="alert-text" v-for="(error, i) in errors" :key="i">{{ error }}</div>
        </div>

        <b-form-group id="example-input-group-1" label label-for="example-input-1">
          <b-form-input
            class="form-control form-control-solid h-auto py-5 px-6"
            id="example-input-1"
            name="example-input-1"
            v-model="$v.form.email.$model"
            aria-describedby="input-1-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback">تلفن همراه اجباری است</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group id="example-input-group-2" label label-for="example-input-2">
          <b-form-input
            class="form-control form-control-solid h-auto py-5 px-6"
            type="password"
            id="example-input-2"
            name="example-input-2"
            v-model="$v.form.password.$model"
            :state="validateState('password')"
            aria-describedby="input-2-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-2-live-feedback">رمز عبور اجباری است</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="کد تایید">
            <b-row>
              <b-col cols="5">
                <b-form-input
                  v-model="form.captcha"
                  placeholder="کد تایید"
                ></b-form-input>
              </b-col>
              <b-col cols="5">
                <b-img center fluid :src="captcha_img" style="height:38px"></b-img>
              </b-col>
              <b-col>
                <b-button variant="warning" @click="resetCaptcha"
                  ><b-icon icon="arrow-clockwise"></b-icon
                ></b-button>
              </b-col>
            </b-row>
          </b-form-group>

        <!--begin::Action-->
        <div class="form-group d-flex flex-wrap justify-content-between align-items-center">
          <button
            ref="kt_login_signin_submit"
            class="btn btn-primary btn-block font-weight-bold px-9 py-4 my-3 font-size-3"
          >ورود</button>
        </div>
        <!--end::Action-->
      </b-form>
      <!--end::Form-->
    </div>
    <!--end::Signin-->
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-left: 3.5rem !important;
}
</style>

<script>
import VueRecaptcha from "vue-recaptcha";
import { mapState } from "vuex";
import { LOGIN, LOGOUT } from "@/core/services/store/auth.module";

import { validationMixin } from "vuelidate";
import { email, minLength, required } from "vuelidate/lib/validators";
import httpHelper from "../../helpers/httpHelper";
import sessionHelper from "../../helpers/sessionHelper";
export default {
  mixins: [validationMixin],
  name: "login",
  components: {
    "vue-recaptcha": VueRecaptcha
  },
  data() {
    return {
      // Remove this dummy login info
      form: {
        email: "",
        password: "",
        captcha: ""
      },
      captcha_img: "",
      errors: []
    };
  },
  validations: {
    form: {
      email: {
        required
      },
      password: {
        required,
        minLength: minLength(3)
      }
    }
  },
  mounted(){
    this.resetCaptcha();
  },
  methods: {
    resetCaptcha() {
      httpHelper.getData('cp').then(res=>{
        this.captcha_img = res.result.img;
        this.form.captcha = '';
        this.form.key = res.result.key;
      })
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onVerify: function(response) {
      if (response) {
        this.form.robot = true;
        this.form.captcha = response;
      }
    },
    resetForm() {
      this.form = {
        email: null,
        password: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const email = this.$v.form.email.$model;
      const password = this.$v.form.password.$model;
      this.errors = [];

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      var data = {
        email: email,
        password: password,
        captcha: this.form.captcha,
        key:this.form.key
      };
      httpHelper
        .postData("users/login", data)
        .then(res => {
          if (res.success == false) {
            this.errors = [res.error];
          } else {
            sessionHelper.setUser(res.result);
            this.$router.push({ name: "dashboard" });
          }
        })
        .finally(() => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    }
  },
  computed: {}
};
</script>
